<template>
  <div class="bg-container page">
    <div class="dong_box">
      <div class="dong_i"></div>
    </div>
    
    <div class="bg-wrapper">
      <div class="login">
        <!-- 右上角语言切换 -->
        <div class="language" @click="$router.push('/Language')">
          <img src="/img/newLogin/icon_lang.png" />
        </div>
        <div class="wrapper">
        
          <!-- <div class="title">{{ $t("auth.login") }}</div> -->
          <div class="logon_box">
            <img :src="siteLogo" />
            <div class="cc">
              {{ $t("q1") }}
            </div>
          </div>
          
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doLogin()"
              >{{$t("auth.login")}}</van-button
            >
            <!-- 底部：左侧隐私政策，右侧注册入口，对称排版 -->
            <div class="c_bott">
              <span class="privacy-link" @click="showPrivacy()">《{{ $t("auth.privacy_policy") }}》</span>
              <div class="register-link" @click="toRegister()">
                <span>{{$t("auth.no_account")}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 隐私政策弹窗 -->
    <van-popup v-model="showPrivacyPopup" round closeable position="bottom" :style="{ height: '70%' }">
      <div class="popup-content">
        <div class="popup-title">{{ $t("auth.privacy_title") }}</div>
        <div class="popup-body">{{ privacyContent }}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import http from '@/http/index'

export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      lang: 'zh',
      password: this.inputValue,
      passwordType: "password",
      showPrivacyPopup: false,
      privacyContent: "",
      siteLogo: "/img/clogo.png",
    };
  },
  beforeMount(){
    // 如果没有设置语言，默认设置为日语
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang","ja")
    }
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || 'ja';
    this.loadPrivacy();
    this.loadSiteLogo();
  },
  methods: {
    // 加载后台系统管理--基本配置的站点LOGO，未配置时使用默认图
    async loadSiteLogo() {
      try {
        const result = await http({
          method: 'get',
          url: 'base_info'
        });
        if (result && result.code === 200 && result.data && result.data.ico) {
          this.siteLogo = result.data.ico;
        }
      } catch (error) {
        console.error('加载站点LOGO失败:', error);
      }
    },
    // 加载隐私政策内容
    async loadPrivacy() {
      try {
        const result = await http({
          method: 'get',
          url: 'agreement_info'
        });
        if (result && result.code === 200 && result.data) {
          this.privacyContent = result.data.privacy || '';
        }
      } catch (error) {
        console.error('加载隐私政策失败:', error);
      }
    },
    // 打开隐私政策弹窗
    showPrivacy() {
      this.showPrivacyPopup = true;
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: { 
          username: this.username, 
          password: this.password,
           lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-field__control{
  color: #e6b98a;
}
.dong_box{
  height: 100%;
  @keyframes bg-data-v-8175861c {
      0%, 100% {
        background-position-x: 0;
      }
      50% {
        background-position-x: 100%;
      }
    }
  .dong_i{
    height: 100%;
      height: 100%;
      width: auto;
      animation: bg-data-v-8175861c 20s linear infinite;
      background: url(/img/newLogin/login.jpg) no-repeat 0 0;
      background-size: auto 100%;
      height: 100%;
    
  }
}

.login {
  height: 100%;
  position: relative;
}
.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0;
  border-bottom: solid 1px transparent;
}
.bg-container .bg-wrapper{
  background: #00000082 no-repeat 0 0;
  background-size: 100% 100%;
}
.logon_box {
  text-align: center;
  padding-top: 100px; /* 增加顶部间距，让整体往下走 */

  img {
    width: 280px; /* 调大 Logo 宽度 */
    max-width: 80%;
    height: auto;
    object-fit: contain;
  }

  .cc {
    padding-top: 24px; /* 稍微增加底部文案的间距 */
    color: #ccc;
    /* 750设计稿字号，经postcss换算为vw；勿用12~19px小档，手机上会过小 */
    font-size: 26px;
    line-height: 40px;
  }
}
.language{
		position: fixed;
		top: 10px;
		right: 40px;
		height: 62px;
		z-index: 10;
    
		img{
			height: 70%;
		}
	}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 55%; /* 从 45% 放大到 55% */
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.login .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
  margin-top: 30px; /* 在标题上方加点间距，让下面的输入框进一步下移 */
}
.login .wrapper .loginForm {
  padding: 40px 60px 20px; /* 增加顶部的内边距让输入框往下走 */
}
.login .wrapper .loginForm .input {
  padding: 26px 20px;
  margin-top: 40px;
  border-radius: 10px;
  text-align: center;
  // line-height: 80px;
  font-size: 30px;


  width: 100% !important;
  height: 100%;
  box-sizing: border-box;

  background: linear-gradient(120deg, #212121, #313131);
  border: 2px solid #766350;
  color: #e6b98a;
 
}

.c_bott{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 20px;
  color: #bfa77c;
  font-size: 25px;
  
  .privacy-link {
    color: #bfa77c;
    cursor: pointer;
    transition: color 0.3s ease;
    
    &:hover {
      color: #e6b98a;
    }
  }
  
  .register-link {
    cursor: pointer;
    transition: color 0.3s ease;
    
    &:hover {
      color: #e6b98a;
    }
  }
}

/* 隐私政策弹窗样式 */
.popup-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #2b2b2b;
  border-radius: 20px 20px 0 0;
}

.popup-title {
  text-align: center;
  font-size: 34px;
  font-weight: 700;
  color: #e6b98a;
  padding: 35px 20px 20px;
  border-bottom: 1px solid #3a3a3a;
  flex-shrink: 0;
}

.popup-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 25px 30px 40px;
  font-size: 26px;
  line-height: 44px;
  color: #d8d8d8;
  white-space: pre-wrap;
  word-break: break-word;
}
::v-deep .van-cell::after{
  display: none;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.login .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .wrapper .loginForm .reset-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
}
.login .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.login .wrapper .loginForm .active {
}
.login .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 80px;
  border-radius: 50px;
  color: #68302c;
  background: linear-gradient(#fde3ca, #e7b486);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
</style>
